export default __webpack_public_path__ + "static/media/plt2.fe4d2ead.png";